export const PRIVACY_URL = 'https://app.zetijuris.com.br/privacy';
export const TERMS_URL = 'https://app.zetijuris.com.br/terms';
export const CHANGELOG_API_URL = '';

export const REPLY_POLICY = {
  FACEBOOK: 'https://developers.facebook.com/docs/messenger-platform/policy/policy-overview',
  WHATSAPP_CLOUD: 'https://developers.facebook.com/docs/whatsapp/cloud-api/policy-enforcement',
  TIKTOK: 'https://business.tiktok.com/',
  TWILIO_WHATSAPP: 'https://www.twilio.com/docs/whatsapp/guidance-overview',
};

export default {
  PRIVACY_URL,
  TERMS_URL,
  CHANGELOG_API_URL,
  REPLY_POLICY,
};
